import "./Promo.css";
import { useNavigate } from "react-router-dom";

function Promo({ isLogin }) {
  const navigate = useNavigate();

  const goRegister = () => navigate("/sign-up");
  const goContent = () => navigate("/content");

  return (
    <section className={`promo ${isLogin ? "promo--login" : ""}`}>
      <div className="promo-block">
        <div className="promo-container">
          <h1 className="promo__title">
            Онлайн-курсы по проектированию мебели
          </h1>

          

          {!isLogin && (
            <>
              <p className="promo__subtitle">
                Первые уроки — бесплатно после регистрации
              </p>
            <button className="promo__button" onClick={goRegister}>
              Начать <span className="promo__button-accent">бесплатно</span> →
            </button>
            </>
          )}
          {isLogin && (
            <>
             <p className="promo__subtitle promo__subtitle_login">Доступные программы обучения</p>
            <button className="promo__button" onClick={goContent}>
              Перейти к программам
            </button>
            </>
          )}
        </div>

        <div className="promo__img"></div>
      </div>
    </section>
  );
}

export default Promo;
